import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useForm } from '../../../hooks/useForm';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select } from '@mui/material';
import { getListTypesComponent } from '../../../redux/actions/flows';
import { useDispatch } from 'react-redux';

const EMPTY_FORM = {
    type_component: '',
    subtype_component: '',
    order: '',
    description: '',
    input: '-1',
    replace: '',
    insert: '',
    body: {},
};

export const CreateComponent = ({ flowManager, open, data, orders, typeAction, onSave, setOpen, getImputValid }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [{ userSession }] = useDataAuth();
    const { listTypesComponent, listSubTypesComponent, getSubTypesComponent } = flowManager;
    const [listImput, setlistImput] = useState(['-1']);
    const [errors, setErrors] = useState({});
    const isEdit = typeAction === 'EDIT';

    const getInitObject = () => {
        if (isEdit && data) {
            return {
                ...EMPTY_FORM,
                ...data,
                description: data.description || '',
                input: data.input || '-1',
                replace: data.replace || '',
                insert: data.insert || '',
                body: data.body || {},
            };
        }
        return {
            ...EMPTY_FORM,
            order: orders?.nextOrder || '',
        };
    };

    const [
        { type_component, subtype_component, order, description, replace, input, insert, body },
        handleInputChange,
        handleDirectInputChange,
        setAllInfo,
    ] = useForm(getInitObject());

    const handleSelectType = (obj) => {
        handleDirectInputChange(obj.name, obj.value);
        handleDirectInputChange('subtype_component', '');
        getSubTypesComponent(obj.value);
        setErrors((prev) => ({ ...prev, type_component: undefined, subtype_component: undefined }));
    };

    const handleOrderChange = (event) => {
        const nextOrder = event.target.value;
        handleDirectInputChange('order', nextOrder);
        const validInputs = getImputValid(nextOrder);
        setlistImput(validInputs);
        if (input && !validInputs.includes(input)) {
            handleDirectInputChange('input', '-1');
        }
        setErrors((prev) => ({ ...prev, order: undefined }));
    };

    const validate = () => {
        const nextErrors = {};
        if (!isEdit) {
            if (!type_component) nextErrors.type_component = 'Requerido';
            if (!subtype_component) nextErrors.subtype_component = 'Requerido';
        }
        if (!order) nextErrors.order = 'Requerido';
        if (input && input !== '-1' && listImput.length && !listImput.includes(input)) {
            nextErrors.input = 'El input debe ser menor al orden del componente';
        }
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;
        const dto = {
            type_component,
            subtype_component,
            order,
            description,
            replace,
            input,
            insert,
            body: body || {},
        };
        onSave(dto, data?.order);
        setOpen(false);
    };

    useEffect(() => {
        if (!open) return;
        setAllInfo(getInitObject());
        setErrors({});
        if (listTypesComponent.length === 0) {
            dispatch(getListTypesComponent(userSession.token));
        }
        if (isEdit && data?.type_component) {
            getSubTypesComponent(data.type_component);
        }
        const initialOrder = isEdit ? data?.order : orders?.nextOrder;
        setlistImput(getImputValid(initialOrder));
    }, [open, typeAction, orders?.nextOrder, data?.order]);

    useEffect(() => {
        if (!order) {
            setlistImput(['-1']);
            return;
        }
        const validInputs = getImputValid(order);
        setlistImput(validInputs);
        if (input && input !== '-1' && !validInputs.includes(input)) {
            handleDirectInputChange('input', '-1');
        }
    }, [order]);

    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                maxWidth='sm'
                disableEscapeKeyDown
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        {isEdit
                            ? t('flows.flowComponentFormTitleEdit', { defaultValue: 'Editar input o posición' })
                            : t('flows.flowComponentFormTitle')}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ marginTop: 2 }}>
                        <Grid container spacing={2}>
                            {!isEdit && (
                                <>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            id='Idtype_component'
                                            name='type_component'
                                            select
                                            fullWidth
                                            required
                                            label='Tipo'
                                            variant='outlined'
                                            value={type_component || ''}
                                            onChange={(e) => handleSelectType(e.target)}
                                            size='small'
                                            error={Boolean(errors.type_component)}
                                            helperText={errors.type_component}
                                        >
                                            <MenuItem value='' disabled>
                                                Seleccione una opción
                                            </MenuItem>
                                            {listTypesComponent.map((item) => (
                                                <MenuItem
                                                    key={item.type_component}
                                                    value={item.type_component}
                                                >
                                                    {item.type_component}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            id='Idsubtype_component'
                                            name='subtype_component'
                                            select
                                            fullWidth
                                            required
                                            label='Sub tipo'
                                            variant='outlined'
                                            value={subtype_component || ''}
                                            onChange={handleInputChange}
                                            size='small'
                                            disabled={!type_component}
                                            error={Boolean(errors.subtype_component)}
                                            helperText={errors.subtype_component}
                                        >
                                            <MenuItem value='' disabled>
                                                Seleccione una opción
                                            </MenuItem>
                                            {listSubTypesComponent.map((item) => (
                                                <MenuItem
                                                    key={item.subtype_component}
                                                    value={item.subtype_component}
                                                >
                                                    {item.subtype_component}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </>
                            )}

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <FormControl fullWidth required size='small' error={Boolean(errors.order)}>
                                    <InputLabel>Orden</InputLabel>
                                    <Select
                                        name='order'
                                        label='Orden'
                                        value={order || ''}
                                        onChange={handleOrderChange}
                                    >
                                        {(orders?.listOrders || []).map((item) => (
                                            <MenuItem key={item} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {!isEdit && (
                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <TextField
                                        fullWidth
                                        label='Descripción'
                                        InputLabelProps={{ shrink: true }}
                                        size='small'
                                        variant='outlined'
                                        name='description'
                                        value={description || ''}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            )}

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <FormControl fullWidth size='small' error={Boolean(errors.input)}>
                                    <InputLabel>Input asociado</InputLabel>
                                    <Select
                                        name='input'
                                        label='Input asociado'
                                        value={input || '-1'}
                                        onChange={handleInputChange}
                                    >
                                        {listImput.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                {item === '-1' ? 'Sin input (-1)' : item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {!isEdit && type_component === 'parser' && (
                                <>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            fullWidth
                                            label='Replace'
                                            InputLabelProps={{ shrink: true }}
                                            size='small'
                                            variant='outlined'
                                            name='replace'
                                            value={replace || ''}
                                            onChange={handleInputChange}
                                            helperText='Orden a reemplazar (debe existir en el flujo)'
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            fullWidth
                                            label='Insert'
                                            InputLabelProps={{ shrink: true }}
                                            size='small'
                                            variant='outlined'
                                            name='insert'
                                            value={insert || ''}
                                            onChange={handleInputChange}
                                            helperText='Ej: [01].attachmentsProcess'
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>

                        <Box>
                            <ActionButtons
                                onCancel={() => setOpen(false)}
                                onSubmit={handleSubmit}
                                submitLabel='Guardar'
                            />
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};
